import React from 'react'
import { useForm } from 'react-hook-form'
import {
  Container, TextField, Grid, Button, Typography, RadioGroup, FormControlLabel, Radio, Paper,
  Select, Avatar,
} from '@material-ui/core'
import HowToRegRoundedIcon from '@material-ui/icons/HowToRegRounded'
import { Alert } from '@material-ui/lab'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import { signupSchema } from '../../../utils/User/validation'
import style from './index.module.css'
import { signupRequest } from '../../../redux-saga/User/Signup/Reducer'
import { districts } from '../../../utils/User/mp.district.json'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'

const SignUp = () => {
  const dispatch = useDispatch()
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(signupSchema),
  })
  const history = useHistory()
  const error = useSelector((state) => state.signup.error)
  // const response = useSelector((state) => state.signup.user)
  const onSubmit = async ({
    contact, name, email, username, password, district,
  }) => {
    await dispatch(signupRequest({
      contact, name, email, username, password, district, history,
    }))
  }
  return (
    <Container spacing={ 5 } className={ style.back }>
      <Paper elevation={ 24 }>
        <Grid container spacing={ 4 } direction='column' justify='center' alignItems='center'>
          <Grid item className={ style.space }>
            <Typography variant='h4'> Sign Up </Typography>
          </Grid>
          <Grid container spacing={ 2 } justify='center' alignItems='center'>
            <Grid item spacing={ 2 } className={ style.space }>
              <Avatar spacing={ 2 } className={ style.space } item variant='contained' color='primary'>
                <HowToRegRoundedIcon />
              </Avatar>
            </Grid>
          </Grid>
          <form onSubmit={ handleSubmit(onSubmit) }>
            <Grid container spacing={ 2 }>
              <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
                <TextField
                  variant='outlined'
                  label='Contact (Required)'
                  fullWidth
                  inputRef={ register }
                  name='contact'
                />
                <p className={ style.error }>{errors.contact?.message}</p>
              </Grid>
              <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
                <TextField
                  variant='outlined'
                  label='Name (Required)'
                  fullWidth
                  inputRef={ register }
                  name='name'
                />
                <p className={ style.error }>{errors.name?.message}</p>
              </Grid>
            </Grid>
            <Grid container spacing={ 2 }>
              <Grid className={ style.space } xs={ 12 } sm={ 12 }>
                <TextField
                  variant='outlined'
                  label='Email'
                  fullWidth
                  name='email'
                  inputRef={ register }
                />
                <p className={ style.error }>{errors.email?.message}</p>
              </Grid>
            </Grid>
            <Grid container spacing={ 2 }>
              <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
                <TextField
                  variant='outlined'
                  label='Username'
                  fullWidth
                  name='username'
                  inputRef={ register }
                />
                <p className={ style.error }>{errors.username?.message}</p>
              </Grid>
              <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
                <TextField
                  variant='outlined'
                  fullWidth
                  label='Password (Required)'
                  inputRef={ register }
                  name='password'
                />
                <p className={ style.error }>{errors.password?.message}</p>
              </Grid>
            </Grid>
            <Grid container spacing={ 2 }>
              <Grid item className={ style.space } xs={ 12 }>
                <Select
                  native
                  variant='outlined'
                  fullWidth
                  inputRef={ register }
                  name='district'
                >
                  <option label='Select District' />
                  {
                    districts.map((district) => (
                      <option key={ district } value={ district }>{ district }</option>
                    ))
                  }
                </Select>
              </Grid>
            </Grid>
            <Grid container spacing={ 2 } justify='center' alignItems='center'>
              {
                  error
                    ? (
                      <Alert severity='error'>
                        User Already Exit !! Try Login :(
                      </Alert>
                    )
                    : <></>
                }

              <Grid container spacing={ 2 } className={ style.bottom } justify='center' alignItems='center'>
                <Grid item>
                  <Button
                    variant='contained'
                    color='secondary'
                    type='submit'
                  >
                    Sign-Up
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
          <Grid>
            <p className={ style.pad }>
              Already a member
              <Link to={ ROUTE.LOGIN }>
                &ensp;Login&ensp;
              </Link>
            </p>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  )
}

export default SignUp
